import { assetsDashboardsDetailsPageEntryPoint as assetsDashboardsDetailsPageEntryPointSpa } from '@jira/spa-apps__servicedesk-cmdb-assets-dashboards/src/assetsDashboardsDetailsPageEntryPoint.entrypoint.tsx';
import AssetsSpinner from '@jira/assets-app__spinner/src/SpinnerView.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServicedeskPageContextResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { assetsDashboardsSemanticModelResource } from '@jira/router-resources__viz-platform/src/assetsDashboardsSemanticModelResource.tsx';
import { assetsDashboardsDetailRoute } from '@jira/router-routes__assets-app-routes/src/assetsDashboardsDetailRoute.tsx';
import { getAssetsAppResources } from '@jira/router-routes__servicedesk-cmdb-entries/src/common/getCmdbResources.tsx';
import {
	LazyAssetsLayout,
	AssetsLayout,
} from '@jira/assets-app__layout/src/LayoutAssetsLayout.tsx';
import { AssetsPageConfigContainer } from '@jira/assets-app__page-config-container/src/AssetsPageConfigContainer.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { APP_NAMES, toPackageName } from '@jira/servicedesk__common/src/toPackageName.tsx';
// eslint-disable-next-line jira/import/file-extension-required
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const assetsDashboardsDetailsPageEntryPoint = createChromelessEntryPoint({
	main: assetsDashboardsDetailsPageEntryPointSpa,
});

export const assetsDashboardsDetailRouteEntry: Route = createEntry(
	assetsDashboardsDetailRoute,
	() => ({
		group: 'assets',
		LayoutOverrideComponent: AssetsLayout,
		PageConfigContainerOverride: AssetsPageConfigContainer,
		skeleton: AssetsSpinner,
		entryPoint: () => assetsDashboardsDetailsPageEntryPoint,
		pageId: () => 'spa-apps/servicedesk/insight/cmdb-assets-dashboards-detail-page',
		resources: [
			...getAssetsAppResources(),
			...getServicedeskPageContextResources(),
			resourceWithCondition(
				() => fg('platform_avp_enable_jsm_assets_metrics'),
				assetsDashboardsSemanticModelResource,
			),
		],
		forPaint: [LazyAssetsLayout],
		meta: {
			reporting: {
				id: APP_NAMES.INSIGHT_ASSETS_DASHBOARDS_DETAIL_PAGE,
				packageName: toPackageName(APP_NAMES.INSIGHT_ASSETS_DASHBOARDS_DETAIL_PAGE),
				teamName: 'ITSM SAGA',
			},
		},
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
